var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import * as React from "react";
import { v4 } from "uuid";

function SvgBack(_a, svgRef) {
  var title = _a.title,
      _titleId = _a.titleId,
      props = __rest(_a, ["title", "titleId"]);

  var titleId = _titleId !== null && _titleId !== void 0 ? _titleId : title ? "icon-title-" + v4() : undefined;
  return React.createElement("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: false,
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? React.createElement("title", {
    id: titleId
  }, title) : null, React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 12l8.571-9L17 4.5 9.857 12 17 19.5 15.571 21 7 12z",
    fill: "currentColor"
  }));
}

var ForwardRef = React.forwardRef(SvgBack);
export default ForwardRef;